import { render } from "./report_input_update.vue?vue&type=template&id=befbf8d4&scoped=true"
import script from "./report_input_update.vue?vue&type=script&scoped=true&lang=js"
export * from "./report_input_update.vue?vue&type=script&scoped=true&lang=js"

import "./report_input_update.vue?vue&type=style&index=0&id=befbf8d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-befbf8d4"]])

export default __exports__